/* eslint-disable header/header */
export var name = "msal";
export var version = "1.4.12";
//# sourceMappingURL=packageMetadata.js.map